import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type IncidentCommandCenterOnboardingEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const incidentCommandCenterOnboardingEntryPoint: EntryPoint<
	IncidentCommandCenterOnboardingEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<IncidentCommandCenterOnboardingEntryPointComponent>(
		/* webpackChunkName: "async-products-jsm-incident-command-center", jiraSpaEntry: "async-products-jsm-incident-command-center" */ './IncidentCommandCenterOnboardingPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
